const handleCategoryLink = (link) => {
  const url = link.startsWith('/') ? link : `/${link}`;
  if (url?.startsWith('/b/')) return url
  if (url?.startsWith('/c/')) return url
  return `/c${url}`
}
export const handleLinkByTypeV2 = (link, type) => {
  const baseUrl = process.env.NEXT_PUBLIC_WEBSITE_URL
  const isFullUrl = link?.startsWith('http') || link?.startsWith('https');
  const isExternal = isFullUrl && !link?.includes(baseUrl);
  if (isExternal) return link;
  const url = isFullUrl ? link.replace(baseUrl, '') : link
  const updatedUrl = url?.startsWith('/') ? url : `/${url}`;
  switch (type) {
    case 'category':
      return handleCategoryLink(updatedUrl);
    case 'product':
      return updatedUrl
    default:
      return updatedUrl;
  }

};

export const getImageByLocale = (image, locale, isMobile) => {
  return isMobile ? image?.[`mobile-img-${locale}`] : image?.[`img-${locale}`];
};
